<template>
    <div>
        <b-row>
            <b-col cols="12">
                <app-sub-title text="Gráficos Generales"></app-sub-title>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" md="4">
                <app-pie-chart title="PQR's por Tipo" :chart-data="byType"></app-pie-chart>
            </b-col>
            <b-col cols="12" md="4">
                <app-pie-chart title="PQR's por Estado" :chart-data="byStatus"></app-pie-chart>
            </b-col>
            <b-col cols="12" md="4">
                <app-pie-chart title="PQR's por Categoría" :chart-data="byCategory"></app-pie-chart>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import PieChart from '../../../../../Reporting/Charts/PieChart';
import { processByType, processByStatus, processByCategory } from '../../processDataFunctions';
import reportingRepository from '../../../../../../repositories/reporting.repository';
export default {
    components: {
        appPieChart: PieChart
    },
    data: () => ({
        selectedClient: null,
        byType: [],
        byStatus: [],
        byCategory: []
    }),
    methods: {
        async loadClientIndicators() {
            try{
                const rr = {...reportingRepository};
                const {data} = await rr.getPqrClientIndicators(0);

                this.byType = processByType(data.byType);
                this.byStatus = processByStatus(data.byStatus);
                this.byCategory = processByCategory(data.byCategory);
            } catch(err) {
                toastr.error(`Ocurrió un error al cargar los indicadores del cliente [${err.message}]`);
            }

        },
        onSelectClient() {
            this.loadClientIndicators();
        }
    },
    created() {
        this.loadClientIndicators();
    }
}

</script>